/**
 * `?assistant=1` on `/create-task` is set by "Jump right in" and "Add new
 * task". Whether the Spark assistant starts open on a real entry follows the
 * user's stored preference, not the param; the guided demo tour never shows
 * it.
 */
export const WIZARD_ASSISTANT_QUERY_PARAM = 'assistant';
export const WIZARD_ASSISTANT_QUERY_VALUE = '1';

/**
 * `users.preferences` key: `true` once the user closed the panel, `false`
 * once they reopened it from the question-mark button. The wizard starts the
 * panel closed when it is `true`, open otherwise (new accounts included).
 */
export const WIZARD_ASSISTANT_DISMISSED_PREF = 'wizard_assistant_dismissed';

/** Accessible name of the button that brings the closed panel back. */
export const REOPEN_ASSISTANT_LABEL = 'Open assistant';

export const isWizardAssistantSearch = (searchParams) =>
    searchParams?.get?.(WIZARD_ASSISTANT_QUERY_PARAM) === WIZARD_ASSISTANT_QUERY_VALUE;
